export enum DeliverableReports {
  Statement = 'Statement',
  Valuation = 'Valuation',
  JournalEntries = 'JournalEntries',
  Regression = 'Regression',
  JournalEntryAtMaturity = 'JournalEntryAtMaturity',
}
